import React from 'react';
import { FormattedMessage } from 'react-intl';

import AlertMessage, { AlertVariants } from '@/components/route/search/AlertMessage/AlertMessage';

export const NoResultMessage = ({ nights }: { nights: number }) => {
  return (
    <AlertMessage variant={AlertVariants.warning}>
      {nights < 3 ? (
        <>
          <p className="inline md:block" data-testid="no-listings-error">
            <FormattedMessage
              defaultMessage="Hmm… We don’t have any available rentals that match your search."
              id="oPSfhe"
              description="Message for no search results"
            />
          </p>
          <p className="inline ml-1 md:block md:ml-0">
            <FormattedMessage
              defaultMessage="Some rentals may require a longer stay — try selecting more nights or adjusting your filters."
              id="Vb2YSR"
              description="Message for no search results"
            />
          </p>
        </>
      ) : (
        <>
          <p className="inline md:block" data-testid="no-listings-error">
            <FormattedMessage
              defaultMessage="Hmm… We don’t have anything available that matches your criteria."
              id="rIEuFL"
              description="Message for no search results"
            />
          </p>
          <p className="inline ml-1 md:block md:ml-0">
            <FormattedMessage
              defaultMessage="It’s possible the resort is fully booked for those dates—try searching farther ahead or adjusting your filters."
              id="5uAyvd"
              description="Message for no search results"
            />
          </p>
        </>
      )}
    </AlertMessage>
  );
};
